@if ({
  term: queryParamsSearchTermInit$ | async,
  }; as componentData) {
  <app-location-search-input
    [searchInputFieldPlaceholder]="searchTitle"
    [searchTerm]="componentData.term || ''"
    [enableSmallDropDownOnHighResolutionScreen]="enableSmallDropDownOnHighResolutionScreen"
    (selected)="onSelected($event)"
    [showAdvancedSearchDropdown]="showAdvancedSearchDropdown"
    [advancedSearchMobileRoutingPath]="advancedSearchMobileRoutingPath" />
}
